(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    // Mobil menü çekmecesindeki sosyal medya ikonları, footer'a eklenen sosyal
  // medya linkleriyle (sections/footer-utilities.liquid > social-links block)
  // entegre çalışır: footer tek kaynak kabul edilir — footer'da gerçek link
  // varsa çekmecedeki (varsa) eski manuel ikonların üzerine yazılır, böylece
  // footer'a eklenen/değiştirilen her link otomatik çekmecede de görünür.
  // Footer'da hiç link yoksa eski manuel alanlar (varsa) olduğu gibi kalır.
  // Section hydration morph'u slotu server haline (boş) döndürebildiği için
  // MutationObserver ile yeniden uygulanır; klonlanmış içerik `data-synced`
  // ile işaretlenir, tekrar tekrar aynı klonu eklemeyi önler.
  if (!window.__jovenDrawerSocialInit) {
    window.__jovenDrawerSocialInit = true;

    function populateDrawerSocial() {
      var footerWrapper = document.querySelector('.utilities .social-icons__wrapper');
      var footerHasLinks =
        footerWrapper && footerWrapper.querySelector('.social-icons__icon-wrapper:not(.social-icons__icon-wrapper--disabled)');

      var slots = document.querySelectorAll('[data-drawer-social-slot]');
      for (var i = 0; i < slots.length; i++) {
        var slot = slots[i];
        if (!footerHasLinks) continue;
        if (slot.getAttribute('data-synced') === 'true') continue;
        slot.innerHTML = '';
        slot.appendChild(footerWrapper.cloneNode(true));
        slot.setAttribute('data-synced', 'true');
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', populateDrawerSocial);
    } else {
      populateDrawerSocial();
    }

    new MutationObserver(populateDrawerSocial).observe(document.body, { childList: true, subtree: true });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["joven-carousel-dots"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__jovenCarouselDots) return;
    window.__jovenCarouselDots = true;

    var MQ = window.matchMedia('(max-width: 749px)');
    var registry = new WeakMap();

    /* ⚠️ GOTCHA: ürün KARTININ KENDİSİ de bir slideshow içerir (galeri) →
       .jrv-strip içinde `querySelector('slideshow-slides')` şeridin track'ini
       değil, ilk kartın galerisini yakalar (tek görselli kartta 1 slayt →
       "2'den az slayt" diye erken çıkılıyordu). Bu yüzden şerit tipine göre
       AÇIKÇA seçiyoruz. */
    function isStrip(comp) {
      return comp.classList.contains('jrv-strip');
    }

    function scrollerOf(comp) {
      return isStrip(comp) ? comp.querySelector('.jrv-strip__track') : comp.querySelector('slideshow-slides');
    }

    function containerOf(comp, scroller) {
      if (isStrip(comp)) return comp.querySelector('.jrv-strip__viewport');
      return comp.querySelector('slideshow-container') || scroller.parentElement;
    }

    function buildFor(comp) {
      var existing = registry.get(comp);
      if (existing) {
        // Noktalar hâlâ DOM'daysa dokunma; section morph'unda düşmüşse
        // bayat kaydı temizleyip yeniden kur.
        if (existing.nav && existing.nav.isConnected) return;
        teardownFor(comp);
      }
      var scroller = scrollerOf(comp);
      if (!scroller) return;
      var slides = Array.prototype.filter.call(scroller.children, function (el) {
        return el.nodeType === 1;
      });
      if (slides.length < 2) return;
      if (scroller.scrollWidth <= scroller.clientWidth + 4) return;

      var nav = document.createElement('div');
      nav.className = 'joven-dots';
      nav.setAttribute('role', 'tablist');
      nav.setAttribute('aria-label', 'Ürün sıralaması');

      var dots = slides.map(function (slide, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'joven-dots__dot';
        b.setAttribute('aria-label', (i + 1) + '. ürün');
        b.addEventListener('click', function () {
          slide.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        });
        nav.appendChild(b);
        return b;
      });

      var container = containerOf(comp, scroller);
      if (!container) return;
      container.insertAdjacentElement('afterend', nav);

      function setActive(idx) {
        for (var i = 0; i < dots.length; i++) {
          dots[i].classList.toggle('is-active', i === idx);
        }
      }
      setActive(0);

      var io = new IntersectionObserver(function (entries) {
        var best = null;
        entries.forEach(function (e) {
          if (e.isIntersecting && (!best || e.intersectionRatio > best.intersectionRatio)) {
            best = e;
          }
        });
        if (best) {
          var idx = slides.indexOf(best.target);
          if (idx > -1) setActive(idx);
        }
      }, { root: scroller, threshold: [0.5, 0.75, 1] });

      slides.forEach(function (s) { io.observe(s); });
      registry.set(comp, { nav: nav, io: io });
    }

    function teardownFor(comp) {
      var rec = registry.get(comp);
      if (!rec) return;
      rec.io.disconnect();
      if (rec.nav && rec.nav.parentElement) rec.nav.remove();
      registry['delete'](comp);
    }

    function refresh(rebuild) {
      var comps = document.querySelectorAll('slideshow-component.resource-list__carousel, .jrv-strip');
      Array.prototype.forEach.call(comps, function (comp) {
        // Favorilerim şeridinin kartları istemci tarafında geldiği/değiştiği
        // için noktalar bayatlayabilir → o turda önce sökülür.
        if (rebuild === true) teardownFor(comp);
        if (MQ.matches) buildFor(comp);
        else teardownFor(comp);
      });
    }

    var raf;
    var pendingRebuild = false;
    function debounced() {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var rebuild = pendingRebuild;
        pendingRebuild = false;
        refresh(rebuild);
      });
    }
    function debouncedRebuild() {
      pendingRebuild = true;
      debounced();
    }

    if (document.readyState !== 'loading') debounced();
    else document.addEventListener('DOMContentLoaded', debounced);

    if (MQ.addEventListener) MQ.addEventListener('change', debounced);
    else if (MQ.addListener) MQ.addListener(debounced);

    window.addEventListener('resize', debounced);
    document.addEventListener('shopify:section:load', debounced);
    document.addEventListener('shopify:section:unload', debounced);
    // Favorilerim / Son Görüntülenenler şeridi kartlarını istemcide doldurunca.
    document.addEventListener('joven:strip-updated', debouncedRebuild);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["joven-cart-notification"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('joven-cart-notification')) {
    class JovenCartNotification extends HTMLElement {
      connectedCallback() {
        this.panel = this.querySelector('.jcn__panel');
        this.onCartUpdate = this.onCartUpdate.bind(this);
        this.onDocClick = this.onDocClick.bind(this);
        this.onKey = this.onKey.bind(this);
        this.reposition = this.reposition.bind(this);
        document.addEventListener('cart:update', this.onCartUpdate);
        this.querySelectorAll('[data-jcn-close]').forEach((b) => b.addEventListener('click', () => this.close()));
      }

      disconnectedCallback() {
        document.removeEventListener('cart:update', this.onCartUpdate);
        this.unbindOpenListeners();
      }

      onCartUpdate(evt) {
        const d = evt.detail || {};
        const data = d.data || {};
        if (data.source !== 'product-form-component' || data.didError) return;
        const cart = d.resource;
        const variantId = String(d.sourceId || data.variantId || '');
        if (cart && Array.isArray(cart.items)) {
          this.show(cart, variantId);
        } else {
          fetch('/cart.js')
            .then((r) => r.json())
            .then((c) => this.show(c, variantId))
            .catch(() => {});
        }
      }

      show(cart, variantId) {
        const items = (cart && cart.items) || [];
        const item = items.find((i) => String(i.variant_id) === variantId) || items[0];
        if (!item) return;

        const img = this.querySelector('[data-jcn-image]');
        const url = item.image || (item.featured_image && item.featured_image.url) || '';
        if (url) {
          const u = new URL(url, location.origin);
          u.searchParams.set('width', '160');
          img.src = u.href;
          img.alt = item.product_title || '';
          img.closest('.jcn__image-wrap').style.display = '';
        } else {
          img.removeAttribute('src');
          img.closest('.jcn__image-wrap').style.display = 'none';
        }

        this.querySelector('[data-jcn-title]').textContent = item.product_title || '';
        const vt = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
        this.querySelector('[data-jcn-variant]').textContent = vt;
        const money = (cents) =>
          (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '₺';
        const qty = item.quantity > 1 ? item.quantity + ' × ' : '';
        this.querySelector('[data-jcn-price]').textContent = qty + money(item.final_price);

        this.hidden = false;
        this.reposition();
        requestAnimationFrame(() => {
          this.classList.add('jcn--open');
          this.panel.focus({ preventScroll: true });
        });
        this.bindOpenListeners();
      }

      reposition() {
        const icon = document.querySelector('header-actions .action__cart, .header-actions .action__cart');
        const vw = window.innerWidth;
        const mobile = vw < 750;
        let top = 12;
        let right = 10;
        if (icon) {
          const r = icon.getBoundingClientRect();
          if (r.width && r.bottom > 0 && r.bottom < window.innerHeight) {
            top = r.bottom + 10;
            if (!mobile) right = Math.max(10, vw - r.right - 4);
            const caretRight = Math.max(12, vw - right - (r.left + r.width / 2) - 6);
            this.style.setProperty('--jcn-caret-right', Math.min(caretRight, 340) + 'px');
          } else {
            this.style.setProperty('--jcn-caret-right', '-999px');
          }
        }
        this.style.top = top + 'px';
        this.style.right = right + 'px';
      }

      bindOpenListeners() {
        setTimeout(() => document.addEventListener('click', this.onDocClick), 0);
        document.addEventListener('keyup', this.onKey);
        window.addEventListener('resize', this.reposition, { passive: true });
        window.addEventListener('scroll', this.reposition, { passive: true });
      }

      unbindOpenListeners() {
        document.removeEventListener('click', this.onDocClick);
        document.removeEventListener('keyup', this.onKey);
        window.removeEventListener('resize', this.reposition);
        window.removeEventListener('scroll', this.reposition);
      }

      onDocClick(evt) {
        if (!this.contains(evt.target)) this.close();
      }

      onKey(evt) {
        if (evt.code === 'Escape') this.close();
      }

      close() {
        this.classList.remove('jcn--open');
        this.unbindOpenListeners();
        setTimeout(() => {
          this.hidden = true;
        }, 220);
      }
    }
    customElements.define('joven-cart-notification', JovenCartNotification);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["joven-favorite-toggle-global"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('favorite-toggle')) {
    customElements.define(
      'favorite-toggle',
      class extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('.favorite-toggle__button');
          this.handle = this.dataset.handle;
          if (!this.button || !this.handle) return;
          this.sync();
          this.onDocToggle = (e) => {
            if (e.detail && e.detail.handle === this.handle) this.sync();
          };
          document.addEventListener('joven:favorite-toggled', this.onDocToggle);
          this.button.addEventListener('click', (e) => {
            e.preventDefault();
            this.toggle();
          });
        }
        disconnectedCallback() {
          document.removeEventListener('joven:favorite-toggled', this.onDocToggle);
        }
        getFavorites() {
          try {
            return JSON.parse(localStorage.getItem('joven:favorites') || '[]');
          } catch (e) {
            return [];
          }
        }
        sync() {
          const active = this.getFavorites().includes(this.handle);
          this.dataset.active = active ? 'true' : 'false';
          this.button.setAttribute('aria-pressed', active ? 'true' : 'false');
          const label = this.querySelector('.favorite-toggle__label');
          if (label) {
            label.textContent = active ? label.dataset.labelActive : label.dataset.labelAdd;
          }
        }
        toggle() {
          let favs = this.getFavorites();
          const isActive = favs.includes(this.handle);
          if (isActive) {
            favs = favs.filter((h) => h !== this.handle);
          } else {
            favs.unshift(this.handle);
          }
          localStorage.setItem('joven:favorites', JSON.stringify(favs));
          this.sync();
          document.dispatchEvent(
            new CustomEvent('joven:favorite-toggled', {
              detail: { handle: this.handle, active: !isActive },
            })
          );
        }
      }
    );
  }

  if (!customElements.get('favorites-count-icon')) {
    customElements.define(
      'favorites-count-icon',
      class extends HTMLElement {
        connectedCallback() {
          this.bubble = this.querySelector('.cart-bubble');
          this.countEl = this.querySelector('.cart-bubble__text-count');
          this.sync();
          this.onToggle = () => this.sync();
          document.addEventListener('joven:favorite-toggled', this.onToggle);
        }
        disconnectedCallback() {
          document.removeEventListener('joven:favorite-toggled', this.onToggle);
        }
        sync() {
          let favorites = [];
          try {
            favorites = JSON.parse(localStorage.getItem('joven:favorites') || '[]');
          } catch (e) {
            favorites = [];
          }
          const count = favorites.length;
          if (this.countEl) {
            this.countEl.textContent = count === 0 ? '' : count > 99 ? '99+' : String(count);
          }
          if (this.bubble) {
            this.bubble.classList.toggle('visually-hidden', count === 0);
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["joven-recently-viewed-list"] && !Shopify.designMode) return;
  try {
    (function () {
    var KEY = 'joven:recently-viewed';
    if (customElements.get('recently-viewed-products')) return;

    customElements.define('recently-viewed-products', class extends HTMLElement {
      async connectedCallback() {
        var limit = parseInt(this.dataset.limit || '8', 10);
        var current = this.dataset.excludeCurrent || '';
        var cardSection = this.dataset.cardSection || 'joven-card-render';

        var handles = [];
        try { handles = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { handles = []; }

        var show = handles.filter(function (h) { return h && h !== current; }).slice(0, limit);
        if (!show.length) return;

        var track = this.querySelector('.jrv__track');
        if (!track) return;

        var results = await Promise.all(show.map(async function (h) {
          try {
            var res = await fetch('/products/' + encodeURIComponent(h) + '?section_id=' + cardSection, {
              headers: { 'X-Requested-With': 'fetch' }
            });
            if (!res.ok) return null;
            var html = (await res.text()).trim();
            return html && html.indexOf('rv-card') !== -1 ? html : null;
          } catch (e) { return null; }
        }));

        var valid = results.filter(Boolean);
        if (!valid.length) return;
        track.innerHTML = valid.join('');
        this.hidden = false;
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["joven-share-toggle"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('share-toggle')) {
    customElements.define(
      'share-toggle',
      class extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('.share-toggle__button');
          this.confirmEl = this.querySelector('.share-toggle__confirm');
          if (!this.button) return;
          this.button.addEventListener('click', () => this.share());
        }
        async share() {
          const url = this.dataset.url;
          const title = this.dataset.title;
          if (navigator.share) {
            try {
              await navigator.share({ title, url });
              return;
            } catch (e) {
              if (e && e.name === 'AbortError') return;
            }
          }
          try {
            await navigator.clipboard.writeText(url);
            if (this.confirmEl) {
              this.confirmEl.classList.remove('visually-hidden');
              clearTimeout(this._hideTimeout);
              this._hideTimeout = setTimeout(() => {
                this.confirmEl.classList.add('visually-hidden');
              }, 2500);
            }
          } catch (e) {}
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
